import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'loyaltic-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  showHeader = true;

  router: Router;

  constructor( router: Router) { 
    this.router = router;
    if (window.location.href.includes('country') || window.location.href.includes('campaign') ||window.location.href.includes('login') || window.location.href.includes('reports')) {
      this.showHeader = false;
    }
  }

  ngOnInit() {
  }

}
